import React from 'react';
import { black20, spacer12, spacer56, Type, white } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { ParentCategory } from 'lib/sanity/types';
import { urlForImage } from 'utils/sanity';
import { ParentCategoryLink, omitClassName } from 'components/Links';
import { UbiHomePage } from 'utils/ubi/pages/useUbiHome';

const Image = styled.img`
  height: 64px;
  position: absolute;
  top: 25px;
  box-shadow: 0 2px 4px 0 ${black20};

  // This works because in RTL the 'right' property is given precedence to the left and vv for LTR.
  right: calc(100% - 64px + 19px);
  left: calc(100% - 64px + 19px);
  transform: rotate(25deg);

  html[dir='rtl'] & {
    transform: rotate(-25deg) scaleX(-1);
  }
`;

const CardLabel = styled.div`
  padding: ${spacer12};
  position: relative;
  padding-inline-end: ${spacer56};
`;

const CardLink = styled.a`
  text-decoration: none;
  color: ${white};
`;

interface CardProps {
  backgroundColor: string;
}

const Card = styled.div<CardProps>`
  height: 92px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  background-color: ${props => props.backgroundColor};
`;

export interface CategoryCardProps {
  category: ParentCategory;
  index: number;
  ubi: UbiHomePage;
}

const CategoryCard = ({ category, ubi, index }: CategoryCardProps) => {
  return (
    <div role="listitem">
      <ParentCategoryLink
        parentCategorySlug={category.slug}
        eventDefinition={{
          category: 'category_card',
          action: category.slug,
          label: 'home_page',
          value: undefined,
        }}
        ubiFactory={ubi.logCategoryCardLink(category.slug, index)}
        component={omitClassName(CardLink)}
      >
        <Card backgroundColor={category.backgroundColor.hex} data-testid={`categoryCard-${category.title}`}>
          <Image src={urlForImage(category.image.asset, 64)} role="presentation" width={64} height={64} />
          <CardLabel>
            <Type as="p" variant="cello">
              {category.title}
            </Type>
          </CardLabel>
        </Card>
      </ParentCategoryLink>
    </div>
  );
};

export default CategoryCard;
